import * as schemaDaysOff from "~/schemas/schema.days_off.jsx";
import * as actionTypes from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";

export const fetchDaysOff = () => {
  const url = `${Angie.api_url}/day-offs`;
  return {
    types: [actionTypes.FETCH_DAYS_OFF_LOADING, actionTypes.FETCH_DAYS_OFF_SUCCESS, actionTypes.FETCH_DAYS_OFF_ERROR],
    callAPI: () => fetch({ url }),
    payload: {
      schema: schemaDaysOff.arrayOfDaysOff,
    },
    cache: { key: url },
  };
};

export const addDaysOff = (attributes) => {
  return {
    types: [actionTypes.ADD_DAYS_OFF_LOADING, actionTypes.ADD_DAYS_OFF_SUCCESS, actionTypes.ADD_DAYS_OFF_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/day-offs`,
        method: `post`,
        body: attributes,
      }),
    payload: {
      attributes,
      schema: {
        single: schemaDaysOff.daysOff,
      },
    },
  };
};

export const editDaysOff = (daysOffId, attributes) => {
  return {
    types: [actionTypes.EDIT_DAYS_OFF_LOADING, actionTypes.EDIT_DAYS_OFF_SUCCESS, actionTypes.EDIT_DAYS_OFF_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/day-offs/${daysOffId}`,
        method: `put`,
        body: attributes,
      }),
    payload: {
      daysOffId,
      attributes,
      schema: {
        single: schemaDaysOff.daysOff,
      },
    },
  };
};

export const deleteDaysOff = (daysOffId) => {
  return {
    types: [
      actionTypes.DELETE_DAYS_OFF_LOADING,
      actionTypes.DELETE_DAYS_OFF_SUCCESS,
      actionTypes.DELETE_DAYS_OFF_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/day-offs/${daysOffId}`,
        method: `DELETE`,
      }),
    payload: {
      daysOffId,
    },
  };
};
